import Button from "@/components/shared/buttons/button";
import {
  ArrowSquareOut,
  CalendarPlus,
  ShareNetwork,
} from "@phosphor-icons/react/dist/ssr";

import { handleAddToCalendar } from "@/lib/calendarUtils";
import { shareAction } from "@/lib/shareUtils";
import { useTranslations } from "@/i18n/utils";
import { cn, normalizeUrl } from "@/lib/utils";

interface EventSlugButtonsActionProps {
  name: string;
  description: string;
  venueName: string;
  venueAddress: string;
  start: Date;
  end: Date;
  link: string;
  lang: "es" | "en";
  mobile?: boolean;
}

const EventSlugButtonsAction = ({
  name,
  description,
  venueName,
  venueAddress,
  start,
  end,
  link,
  lang,
  mobile = false,
}: EventSlugButtonsActionProps) => {
  const translate = useTranslations(lang);
  const VISIT_EVENT = translate("publicProfile.events.button.visitEvent");
  const ADD_CALENDAR = translate("publicProfile.events.button.addToCalendar");
  return (
    <>
      {link && (
        <a href={normalizeUrl(link)} target="_blank" rel="noopener noreferrer">
          <Button
            buttonType="tertiary"
            color="lime"
            size="lg"
            leftIcon={ArrowSquareOut}
            className={cn("w-full", mobile && "min-w-52")}
          >
            {VISIT_EVENT}
          </Button>
        </a>
      )}
      <Button
        buttonType="tertiary"
        color="white"
        size="lg"
        leftIcon={CalendarPlus}
        onClick={() =>
          handleAddToCalendar({
            title: name,
            description,
            location: `${venueName}, ${venueAddress}`,
            startDate: start ? new Date(start) : undefined,
            endDate: end ? new Date(end) : undefined,
          })
        }
      >
        {!mobile && ADD_CALENDAR}
      </Button>
      <Button
        buttonType="tertiary"
        color="white"
        size="lg"
        aria-label="Share event"
        leftIcon={ShareNetwork}
        onClick={() =>
          shareAction({ title: name, text: description, url: link })
        }
      >
        <span className="sr-only">Share</span>
      </Button>
    </>
  );
};
export default EventSlugButtonsAction;
